export default "__VITE_ASSET__6PbWPs_h__"